import axios from "axios";
import AuthenticationService from "../service/AuthenticationService";

export default (history = null) => {
  const baseURL = process.env.REACT_APP_BACKEND_URL;


  let headers = {};

  if (localStorage.token) {
    console.log("token ---> "+ localStorage.token)
    headers.Authorization = `Bearer ${localStorage.token}`;
  }

  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers,
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }

      // the stored token was refused (account disabled by an admin, or expired): sign out at once
      if (error.response.status === 401 && localStorage.token) {
        const disabled = error.response.data && error.response.data.msg === "ACCOUNT_DISABLED";
        AuthenticationService.logout();
        window.location = "/login?signedOut=" + (disabled ? "disabled" : "expired");
        return new Promise((resolve, reject) => reject(error));
      }

      if (error.response.status === 403) {
        localStorage.removeItem("token");

        if (history) {
          history.push("/auth/login");
        } else {
          window.location = "/auth/login";
        }
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    }
  );

  return axiosInstance;
};
